<mat-toolbar color="primary">
    <!-- Menu toggle -->
    <div class="side-nav-toggle">
        <button mat-icon-button class="toggle-button" (click)="sidenav.toggle()">
            <mat-icon>menu</mat-icon>
        </button>
    </div>

    <!-- Logo -->
    <a href="/">
        <div class="logo">
            <div class="svg-logo">
                <img alt="ADB Safegate logo" src="assets/svg/logo.svg" />
            </div>
        </div>
    </a>

    <div class="spacer"></div>

    <!-- Profile -->
    <div class="profile-link">
        <a routerLink="/profile" data-cy="profile-link">
            <mat-icon>person</mat-icon>
            <span>{{ userName | titlecase }}</span>
        </a>
    </div>

    <!-- Time -->
    <app-time-display></app-time-display>
</mat-toolbar>

<!-- Side Menu -->
<nav class="side-menu">
    <mat-sidenav-container>
        <!-- Nav -->
        <mat-sidenav #sidenav [mode]="'over'">
            <mat-nav-list>
                <!-- Side menu list -->
                <div class="side-menu-list" *ngIf="hasSideMenuItems()">
                    <div class="side-menu-list-item" *ngFor="let item of sideMenuItems">
                        <a routerLink="{{ item.router }}" (click)="sidenav.close()">
                            <mat-icon>{{ item.icon }}</mat-icon>
                            <span>{{ item.text }}</span>
                        </a>
                    </div>
                </div>

                <hr *ngIf="hasSideMenuItems()">

                <!-- Side menu footer -->
                <div class="side-menu-footer">
                    <span>{{ projectName }}</span>
                    <span>v{{ projectVersion }}</span>
                </div>
            </mat-nav-list>
        </mat-sidenav>

        <!-- Sidenav Content -->
        <mat-sidenav-content>
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
</nav>
